import React from "react";
import "./Your_Branch.css";

function Your_Branch() {
  return (
    <>
      <section className="Your_Branch">
        <div className="container">
          <div className="Your_Branch_holder">
            <div className="row">
              <div className="col-md-5">
                <div className="heading-holder">
                  <h2>Your</h2>
                  <h3>
                    Brand, <br />
                    Story,
                    <br /> Strategy
                  </h3>
                </div>
              </div>

              <div className="col-md-7">
                <div className="content-holder">
                  <div className="text-holder">
                    <h3>
                      At ReachOut Media Tech Pvt. Ltd., we believe in the power
                      of storytelling.
                    </h3>
                    <p>
                      Every brand has a unique voice, and we’re here to amplify
                      it. Whether you’re a small business trying to get noticed
                      or a large corporation seeking expansive reach, we craft
                      personalized advertising strategies that align with your
                      goals and vision.
                    </p>
                    <p>
                      From visually stunning ads on digital screens at Videowala Bus Stand to SEO-powered digital marketing campaigns
                      that increase your online visibility, our team works
                      tirelessly to make sure your brand stands out.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Your_Branch;
